import React from "react";
import DiscountIcon from "@mui/icons-material/Discount";
const SubscripitonRegister = [
  [
    "Subscription Register",
    "/admin/register/subscription",
    <DiscountIcon sx={{ fontSize: "2rem", ml: "0.3rem" }}></DiscountIcon>,
  ],
];

export default SubscripitonRegister;
